import { observer } from "mobx-react-lite";
import { useState,useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GoogleAuthProvider, signInWithPopup,signInWithEmailAndPassword } from "firebase/auth";
import { auth, db} from "../../../firestore-config";
import { addDoc, collection, getDocs, query, where } from "firebase/firestore";
import {quantityvalue} from "../../../app/common/options/categoryOptions";
import ProductGallery from "./ProductGallery";
import GalleryComponent from "./GalleryComponent";
import GalleryLayout1 from "../../../app/common/controls/GalleryLayout1";
import GalleryLayout2 from "../../../app/common/controls/GalleryLayout2";
import {useStore} from "../../../app/stores/rootStore";
export default observer(function ResponsiveProductPage() {
    const [toggleBtn, setToggleBtn] = useState(true);    
  const toggle = () => setToggleBtn(val => !val);
  const { commonStore,modalStore,productsStore,
    userStore:{user,setUser}} = useStore();
  const navigate = useNavigate();
  const {loadAll,selectedItem,setProduct,setProductReload} = productsStore;
  const { id } = useParams();
  const [message, setMessage] = useState("Please go next to login in with your google account to proceed next steps");
  const [quantity, setQuantity] = useState(1);
  const [totalamount, setTotalAmount] = useState(0);
  const googleProvider = new GoogleAuthProvider();
  const signInWithGoogle = async () => {
    try {
      const res = await signInWithPopup(auth, googleProvider);
      const user = res.user;      
      const q = query(collection(db, "users"), where("uid", "==", user.uid));
      const docs = await getDocs(q);
      const newuser = 
        {
            uid: user.uid,
          name: user.displayName,
          token: user.refreshToken,
          email:user.email,
          authProvider: "google",
          email: user.email,
          active: false,
          photoUrl:user.photoURL
        }
      if (docs.docs.length === 0) {            
        await addDoc(collection(db, "users"),newuser);            
      }
      setUser(newuser);
      setMessage(`Welcome, ${newuser.name}`)
      navigate('/thankyou');
    } catch (err) {
      console.error(err);      
    }
  };
    const products = [
    { id: 1, name: 'Product 1', imageUrl: '/assets/images/pattu-soft-silk-saree-1.jpeg', price: '$19.99' },
    { id: 2, name: 'Product 2', imageUrl: '/assets/images/royal-rajwari-katan-silk.jpeg', price: '$29.99' },
    { id: 3, name: 'Product 3', imageUrl: '/assets/images/rajwari-katan-silk-minakari-saree.jpg', price: '$39.99' },
  ];
      const currentyear = new Date().getFullYear();
    const randomNumberInRange = (min, max) => { 
      return Math.floor(Math.random()  
              * (max - min + 1)) + min; 
  };
    return (
        <>
        <GalleryComponent />        
        <GalleryLayout1 products={products}></GalleryLayout1>       
        <GalleryLayout2 title="Our Collections" products={products}></GalleryLayout2>
<section data-bs-version="5.1" className="slider6 mbr-embla cid-uATOSlQKYb" id="slider6-i">    
    
    <div className="position-relative">
        <div className="mbr-section-head">
            <h4 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2"><strong>New Arrivals</strong></h4>
            
        </div>        
    </div>
</section>
<section data-bs-version="5.1" className="pricing02 healthm5 cid-uAV5l3XCdZ" id="pricing02-k">
    <div className="container-fluid">
        <div className="row">            
            <div className="col-12">
                <div className="items-wrapper">
                    <div className="item features-image">
                        <div className="item-wrapper">
                            <div className="item-img">
                                <div className="image-wrap">
                                    {/* <img src="assets/images/coach-purse-3-250x300.webp" alt="" /> */}
                                    <video  controls autoPlay={true} loop muted>
        <source src="assets/images/fancy-parrot-butta-katan-silk.mp4" type="video/mp4" />
        Your browser does not support the video tag.
              </video>
                                    
                                </div>
                                <div className="date-wrapper">
                                    <p className="item-date mbr-fonts-style display-7">
                                        Rs 14,999
                                    </p>
                                    
                                </div>                                
                            </div>
                            
                            <div className="item-content">                                                       
                                <h4 className="item-title mbr-fonts-style display-7">
                                <strong>Elegant Heritage: Fancy Perrot Buta Katan Silk & Chanderi Saree</strong></h4>                                    
                                <p className="item-text mbr-fonts-style display-4">
                                Experience luxury with our Fancy Perrot Buta Katan Silk and Chanderi Saree, featuring exquisite motifs and a shimmering finish. Perfect for special occasions, this saree combines tradition with contemporary elegance. Elevate your festive look with timeless sophistication.
                                </p>
                                <div className="mbr-section-btn"><a className="btn btn-primary-outline display-4" href="#">Buy
                                    Now</a></div>
                            </div>
                        </div>
                    </div>
                    <div className="item features-image">
                        <div className="item-wrapper">
                            <div className="item-img">
                                <div className="image-wrap">
                                    {/* <img src="assets/images/coach-purse-4-250x300.webp" alt="" /> */}
                                    <video  controls autoPlay={true} loop muted>
        <source src="assets/images/fancy-buta-katan-silk-chanderi-saree.mp4" type="video/mp4" />
        Your browser does not support the video tag.
              </video>
                                </div>
                                <div className="date-wrapper">
                                    <p className="item-date mbr-fonts-style display-7">
                                        Rs 14,499
                                    </p>
                                </div>
                            </div>
                            <div className="item-content">
                                <h4 className="item-title mbr-fonts-style display-7">
                               <strong>Graceful Elegance: Fancy Buta Pallu Katan Silk & Chanderi Saree</strong>
                                </h4>
                                <p className="item-text mbr-fonts-style display-4">
                                Adorn yourself with our Fancy Buta Pallu Katan Silk and Chanderi Saree, showcasing intricate motifs and a luxurious drape. Perfect for celebrations and festive occasions, this saree blends tradition with modern charm. Make a statement with timeless elegance.
                                </p>
                                <div className="mbr-section-btn"><a className="btn btn-primary-outline display-4" href="#">
                                    Buy Now
                                </a></div>
                            </div>
                        </div>
                    </div>
                    <div className="item features-image">
                        <div className="item-wrapper">
                            <div className="item-img">
                                <div className="image-wrap">
                                    {/* <img src="assets/images/burberry-handbag-1-250x300.webp" alt="" /> */}
                                    <video  controls autoPlay={true} loop muted>
        <source src="assets/images/royal-rajwari-chanderi-saree.mp4" type="video/mp4" />
        Your browser does not support the video tag.
              </video>
                                </div>
                                <div className="date-wrapper">
                                    <p className="item-date mbr-fonts-style display-7">
                                        Rs 19,000
                                    </p>
                                </div>
                            </div>
                            <div className="item-content">
                                <h4 className="item-title mbr-fonts-style display-7">
                                Regal Charm: Royal Rajwari Chanderi Katan Silk Saree
                                </h4>
                                <p className="item-text mbr-fonts-style display-4">
                                Embrace opulence with our Royal Rajwari Chanderi Katan Silk Saree, featuring rich textures and intricate craftsmanship. Perfect for grand occasions, this saree exudes timeless grace and sophistication. Elevate your festive attire with regal elegance.
                                </p>
                                <div className="mbr-section-btn"><a className="btn btn-primary-outline display-4" href="#">
                                    Buy Now
                                </a></div>
                            </div>
                        </div>
                    </div>                                       
                </div>
            </div>
        </div>
    </div>
</section>
        </>
    )
})